import { HighConvictionReportKeys } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { InsightCardDetails } from '~/components/insight-card-details/InsightCardDetails';
import { ChatQualityScoreData } from '~/views/alfred/quick-analysis/use-chat/assistant-response.type';
import { AssessmentAccordion } from './assessment-accordion/AssessmentAccordion';
import { RevampAssessmentAccordion } from './assessment-accordion/RevampAssessmentAccordion';
import { AssessmentGauge } from './assessment-gauge/AssessmentGauge';
import styles from './AssessmentWidget.module.scss';
import { useFlags } from '~/stores/use-flags/useFlags';

export const AssessmentWidget = ({
  isFixedIncome = false,
  gaugeValue,
  horizon,
  median,
  checklist,
  titleElement,
  hasHeader = true,
}: ChatQualityScoreData) => {
  const { t } = useTranslation('widget');
  const isUniversalDrawerEnabled = useFlags(state =>
    state.getFeatureFlagState('universal_drawer')
  );

  const {
    CrossBusinessCycles,
    SeveralEpisodes,
    Sparse,
    Frequent,
    HighHitRatioInSample,
    HighHitRatioOutSample,
    HighPathRiskReturn,
    HighPnlDrawDownRatio,
  } = HighConvictionReportKeys;

  const conditionValues = {
    [CrossBusinessCycles]: checklist[CrossBusinessCycles],
    [SeveralEpisodes]: checklist[SeveralEpisodes],
    [Sparse]: checklist[Sparse],
    [Frequent]: checklist[Frequent],
  };

  const backTestValues = {
    [HighHitRatioInSample]: checklist[HighHitRatioInSample],
    [HighHitRatioOutSample]: checklist[HighHitRatioOutSample],
    [HighPathRiskReturn]: checklist[HighPathRiskReturn],
    [HighPnlDrawDownRatio]: checklist[HighPnlDrawDownRatio],
  };

  return (
    <>
      <div className={styles.assessmentTitleSelector}>
        {hasHeader && (
          <h3 className={styles.assessmentTitle}>
            {t('widget:assessment.title')}
          </h3>
        )}
        {titleElement}
      </div>
      <div className={styles.assessmentContentWrapper}>
        <div className={styles.assessmentGaugeWrapper}>
          <AssessmentGauge gaugeValue={gaugeValue} />
        </div>
        {median !== undefined && (
          <div className={styles.headerContentWrapper}>
            <InsightCardDetails
              horizon={horizon}
              median={median}
              isFixedIncome={isFixedIncome}
            />
          </div>
        )}
      </div>
      <div className={styles.assessmentBody}>
        {isUniversalDrawerEnabled ? (
          <>
            <RevampAssessmentAccordion
              title={t('widget:assessment.conditionRobustness')}
              items={conditionValues}
              showHasValue
            />
            <RevampAssessmentAccordion
              title={t('widget:assessment.backTestResult')}
              items={backTestValues}
              showHasValue
            />
          </>
        ) : (
          <>
            <AssessmentAccordion
              title={t('widget:assessment.conditionRobustness')}
              items={conditionValues}
              showHasValue
            />
            <AssessmentAccordion
              title={t('widget:assessment.backTestResult')}
              items={backTestValues}
              showHasValue
            />
          </>
        )}
      </div>
    </>
  );
};
